import { render, staticRenderFns } from "./BookQrCode.vue?vue&type=template&id=ae988164&scoped=true&"
import script from "./BookQrCode.vue?vue&type=script&lang=ts&"
export * from "./BookQrCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae988164",
  null
  
)

export default component.exports